import React from 'react';

import { FontEmphasis } from '@prisjakt/ui/text/variants';
import { HighlightedName } from '../highlighted-name';

import {
  ListItem,
  ListItemButton,
  Labels,
  NameLabel,
  SubListItem,
  SectionLabel,
} from './styles';

import { useAppContext } from 'src/components/app-context';

import type { ProductCollectionTopBrand, Maybe } from 'src/types';
import type { BaseItemProps } from './types';

type Props = BaseItemProps & {
  brands?: Maybe<ProductCollectionTopBrand>[] | null;
  path: string;
};

export const ProductCollectionItem = (props: Props) => {
  const {
    text,
    brands,
    path,

    selected,
    order,
    onClick,
    query,
  } = props;
  const { t } = useAppContext();

  return (
    <>
      <ListItem
        data-test="ProductCollectionItem"
        $selected={selected}
        order={order}
      >
        <ListItemButton onClick={onClick}>
          <Labels>
            <NameLabel containerProps={{ 'data-test': 'NameLabel' }}>
              <HighlightedName query={query}>{text}</HighlightedName>
            </NameLabel>
            <SectionLabel>
              {t('search', 'suggest.product_collection')}
            </SectionLabel>
          </Labels>
        </ListItemButton>
      </ListItem>

      {brands?.map(
        brand =>
          brand && (
            <SubListItem key={brand.text} $selected={false} order={order}>
              <ListItemButton to={`${path}?brand=${brand.id}`}>
                <NameLabel emphasis={FontEmphasis.MEDIUM}>
                  {t('common', 'text.by')} {brand.text}
                </NameLabel>
              </ListItemButton>
            </SubListItem>
          )
      )}
    </>
  );
};
